import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _CURRENCY, _CURRENCY_SYMBOLS, _TIMEZONE, _TIMEZONE_ABBREVIATIO, _DIALING_CODE;
/** @clearscore/config.i18n v2.6.0: 2023-3-8 15:45 (assemble v5.5.3) **/
var CurrencySymbol = {
  GBP: "\xA3",
  ZAR: "R",
  AUD: "$",
  CAD: "$",
  NZD: "$"
};
var Currency = {
  GB: "GBP",
  ZA: "ZAR",
  AU: "AUD",
  CA: "CAD",
  NZ: "NZD"
};
var DialingCode = {
  GB: "+44",
  ZA: "+27",
  AU: "+61",
  CA: "+1",
  NZ: "+64"
};
var Locale = {
  EN_GB: "en-gb",
  EN_ZA: "en-za",
  EN_AU: "en-au",
  EN_CA: "en-ca",
  EN_NZ: "en-nz",
  FR_CA: "fr-ca"
};
var Market = {
  GB: "gb",
  ZA: "za",
  AU: "au",
  CA: "ca",
  NZ: "nz",
  GLOBAL: "global"
};
var TimezoneAbbreviation = {
  EN_GB: "GMT",
  EN_ZA: "SAST",
  BST: "BST",
  EN_AU: "AEST",
  EN_NZ: "NZST"
};
var Timezone = {
  EN_GB: "Europe/London",
  EN_ZA: "Africa/Johannesburg",
  EN_AU: "Australia/Sydney",
  EN_NZ: "NewZealand/Wellington"
};

/* MARKETS */

var GB = 'gb';
var ZA = 'za';
var AU = 'au';
var CA = 'ca';
var NZ = 'nz';
var GLOBAL = 'global';
var MARKETS = [GB, ZA, AU, CA, NZ];
/* LOCALES */

var EN_GB = 'en-gb';
var EN_ZA = 'en-za';
var EN_AU = 'en-au';
var EN_CA = 'en-ca';
var EN_NZ = 'en-nz';
var FR_CA = 'fr-ca';
var LOCALES = [EN_GB, EN_ZA, EN_AU, EN_CA, EN_NZ, FR_CA];
/* CURRENCIES */

var GBP = 'GBP';
var ZAR = 'ZAR';
var AUD = 'AUD';
var CAD = 'CAD';
var NZD = 'NZD';
var CURRENCY = (_CURRENCY = {}, _defineProperty(_CURRENCY, GB, GBP), _defineProperty(_CURRENCY, ZA, ZAR), _defineProperty(_CURRENCY, AU, AUD), _defineProperty(_CURRENCY, CA, CAD), _defineProperty(_CURRENCY, NZ, NZD), _CURRENCY);
var GBP_SYMBOL = '£';
var ZAR_SYMBOL = 'R';
var AUD_SYMBOL = '$';
var CAD_SYMBOL = '$';
var NZD_SYMBOL = '$';
var CURRENCY_SYMBOLS = (_CURRENCY_SYMBOLS = {}, _defineProperty(_CURRENCY_SYMBOLS, GBP, GBP_SYMBOL), _defineProperty(_CURRENCY_SYMBOLS, ZAR, ZAR_SYMBOL), _defineProperty(_CURRENCY_SYMBOLS, AUD, AUD_SYMBOL), _defineProperty(_CURRENCY_SYMBOLS, CAD, CAD_SYMBOL), _defineProperty(_CURRENCY_SYMBOLS, NZD, NZD_SYMBOL), _CURRENCY_SYMBOLS);
/* TIMEZONES */

var GB_TIMEZONE = 'Europe/London';
var ZA_TIMEZONE = 'Africa/Johannesburg';
var AU_TIMEZONE = 'Australia/Sydney';
var NZ_TIMEZONE = 'NewZealand/Wellington';
var TIMEZONE = (_TIMEZONE = {}, _defineProperty(_TIMEZONE, EN_GB, GB_TIMEZONE), _defineProperty(_TIMEZONE, EN_ZA, ZA_TIMEZONE), _defineProperty(_TIMEZONE, EN_AU, AU_TIMEZONE), _defineProperty(_TIMEZONE, EN_NZ, NZ_TIMEZONE), _TIMEZONE);
/* TIMEZONE ABBREVIATIONS */

var GB_TIMEZONE_ABBREVIATION = 'GMT';
var BST_TIMEZONE_ABBREVIATION = 'BST';
var ZA_TIMEZONE_ABBREVIATION = 'SAST';
var AU_TIMEZONE_ABBREVIATION = 'AEST';
var NZ_TIMEZONE_ABBREVIATION = 'NZST';
var TIMEZONE_ABBREVIATION = (_TIMEZONE_ABBREVIATIO = {}, _defineProperty(_TIMEZONE_ABBREVIATIO, EN_GB, GB_TIMEZONE_ABBREVIATION), _defineProperty(_TIMEZONE_ABBREVIATIO, EN_ZA, ZA_TIMEZONE_ABBREVIATION), _defineProperty(_TIMEZONE_ABBREVIATIO, "BST", BST_TIMEZONE_ABBREVIATION), _defineProperty(_TIMEZONE_ABBREVIATIO, EN_AU, AU_TIMEZONE_ABBREVIATION), _defineProperty(_TIMEZONE_ABBREVIATIO, EN_NZ, NZ_TIMEZONE_ABBREVIATION), _TIMEZONE_ABBREVIATIO);
/* DIALING CODES */

var GB_DIALING_CODE = '+44';
var ZA_DIALING_CODE = '+27';
var AU_DIALING_CODE = '+61';
var CA_DIALING_CODE = '+1';
var NZ_DIALING_CODE = '+64';
var DIALING_CODES = [GB_DIALING_CODE, ZA_DIALING_CODE, AU_DIALING_CODE, CA_DIALING_CODE, NZ_DIALING_CODE];
var DIALING_CODE = (_DIALING_CODE = {}, _defineProperty(_DIALING_CODE, GB, GB_DIALING_CODE), _defineProperty(_DIALING_CODE, ZA, ZA_DIALING_CODE), _defineProperty(_DIALING_CODE, AU, AU_DIALING_CODE), _defineProperty(_DIALING_CODE, CA, CA_DIALING_CODE), _defineProperty(_DIALING_CODE, NZ, NZ_DIALING_CODE), _DIALING_CODE);
var index = {
  /* OLD CONSTANTS (js) */
  GB: GB,
  ZA: ZA,
  AU: AU,
  CA: CA,
  NZ: NZ,
  GLOBAL: GLOBAL,
  EN_GB: EN_GB,
  EN_ZA: EN_ZA,
  EN_AU: EN_AU,
  EN_CA: EN_CA,
  EN_NZ: EN_NZ,
  FR_CA: FR_CA,
  GBP: GBP,
  ZAR: ZAR,
  AUD: AUD,
  CAD: CAD,
  NZD: NZD,
  GBP_SYMBOL: GBP_SYMBOL,
  ZAR_SYMBOL: ZAR_SYMBOL,
  AUD_SYMBOL: AUD_SYMBOL,
  CAD_SYMBOL: CAD_SYMBOL,
  NZD_SYMBOL: NZD_SYMBOL,
  MARKETS: MARKETS,
  LOCALES: LOCALES,
  CURRENCY: CURRENCY,
  CURRENCY_SYMBOLS: CURRENCY_SYMBOLS,
  TIMEZONE: TIMEZONE,
  TIMEZONE_ABBREVIATION: TIMEZONE_ABBREVIATION,
  DIALING_CODES: DIALING_CODES,
  DIALING_CODE: DIALING_CODE
};
export { AU, AUD, AUD_SYMBOL, CA, CAD, CAD_SYMBOL, CURRENCY, CURRENCY_SYMBOLS, Currency, CurrencySymbol, DIALING_CODE, DIALING_CODES, DialingCode, EN_AU, EN_CA, EN_GB, EN_NZ, EN_ZA, FR_CA, GB, GBP, GBP_SYMBOL, GLOBAL, LOCALES, Locale, MARKETS, Market, NZ, NZD, NZD_SYMBOL, TIMEZONE, TIMEZONE_ABBREVIATION, Timezone, TimezoneAbbreviation, ZA, ZAR, ZAR_SYMBOL, index as default };